import React from 'react';
import {View} from 'react-native';

import Locale from './../../Locale';
import {Layout, Navbar} from './../../Screen';
import {Form, Button} from './../../Form';
import RPAScreen from './RPAScreen';
import InformationForQuotation from './../components/InformationForQuotation';
import Total from './../components/Total';
import Alert from "./../../components/Alert/Alert";
export default class RPAScreen2 extends RPAScreen {
  buyNow() {
    if (this.state.broker) {
      this.askCustomerToLogin().then(() => this.push("RPA3"));
    } else {
      if (Locale.getPaymentStatus()) {
        this.askCustomerToLogin().then(() => this.push("RPA3"));
      } else {
        this.setState({
          alert: Alert.alert(
            Locale.text.paymentStopService1,
            Locale.text.paymentStopService2,
            [
              {
                text: Locale.text.yes,
                onPress: () => this.setState({ alert: null }),
              },
            ]
          ),
        });
      }
    }
    //this.askCustomerToLogin().then(() => this.push('RPA3'));
  }

  render() {
    const {policy, rpa, payment} = this.state.insuranceProduct;

    const data = [];

    if (payment.promotionCode) {
      data.push(
        {
          label: Locale.text.promotionCodes,
          value: payment.promotionCode,
        }
      );
    }

    if (policy.businessEmail) {
      data.push(
        {
          label: Locale.text.businessEmailMembership,
          value: policy.businessEmail,
        }
      );
    }

    return(
      <Layout alert={this.state.alert}>
        <Navbar
          screen={this}
          title={Locale.text.getAQuote}
        />

        {Locale.text.bravoPassengerProtector}
        {Locale.text.bravoPassengerProtectorLeftPanel}

        <View style={Layout.container}>
          <Form>
            <InformationForQuotation
              planTypeOptions={this.premiumPlanOptions}
              planType={rpa.premiumPlan}
              data={data}
            />

            <Total premium={this.getParam('premium')} />
          </Form>

          <Button withMargin onPress={() => this.buyNow()}>
            {Locale.text.buyNow}
          </Button>
        </View>
      </Layout>
    );
  }
}
